import { ThemedFunctor, BreakpointQueryName } from '@doveit/bricks';
import { css } from 'styled-components';
import variables from '../themes/variables';

export const stickySideAdv: ThemedFunctor = ({
  theme,
  $visible,
}) => css`
  margin-top: ${theme.spaceUnits.mobile.MEDIUM};
  display: none;
  position: sticky;
  transition: opacity .4s ease-out;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block;
    opacity: ${$visible ? 1 : 0};
    pointer-events: ${$visible ? 'all' : 'none'};
    top: calc(${variables.navigationHeight.desktop} + ${theme.spaceUnits.desktop.MEDIUM});
  }
`;
